import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { TaskStatus } from "griptonite-api-client/types/tasks";

import { Task } from "@/core/types";
import { useOptimisticTaskUpdateMutation } from "@/hooks/tasks";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { getStatusLabel } from "../TaskCard/StatusChip";
import { useModal } from "./useModal";

export default function ConfirmRestoreStrippedRoute({
  status,
  task,
}: {
  status: TaskStatus;
  task: Task;
}) {
  const { close } = useModal();
  const venueUuid = useCurrentVenueUuid();
  const mutation = useOptimisticTaskUpdateMutation(venueUuid);
  const mutate = mutation.mutate;

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          Moving this task to <strong>{getStatusLabel(status)}</strong> will restore this route to
          the gym, making it visible to climbers again and removing it from the Archive. Are you
          sure you want to do this?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            mutate({
              task,
              payload: { status },
            });
            close();
          }}
          sx={{ flex: 1 }}
        >
          Continue
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
